import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { api, apiErrorMessage } from '../../services/api'
import { useAuthStore } from '../../context/auth'
import { Button, Input, Field, ErrorText } from '../../components/ui'
import { Logo } from '../../components/brand/Logo'

/** Login del portal de paciente: RUT como llave + clave creada por invitación. */
export function PatientLoginPage() {
  const [rut, setRut] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const setSession = useAuthStore((s) => s.setSession)
  const navigate = useNavigate()

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { data } = await api.post('/auth/patient-login', { rut, password })
      const me = await api.get('/auth/me', { headers: { Authorization: `Bearer ${data.accessToken}` } })
      setSession(me.data, data.accessToken, data.refreshToken)
      navigate('/paciente')
    } catch (err) {
      setError(apiErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-900 p-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl">
        <h1 className="mb-1">
          {/* El logo vuelve al sitio público (pedido de Chejo, minuta 15-09). */}
          <Link to="/" title="Ir al sitio de Cima Sport">
            <Logo className="h-11" />
          </Link>
        </h1>
        <p className="mb-6 text-sm text-gray-500">Portal de pacientes · Tus citas y pagos en línea</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field label="RUT">
            <Input value={rut} onChange={(e) => setRut(e.target.value)} placeholder="12.345.678-5" required autoFocus />
          </Field>
          <Field label="Contraseña">
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </Field>
          <ErrorText>{error}</ErrorText>
          <Button type="submit" variant="cta" className="w-full py-2.5" disabled={loading}>
            {loading ? 'Ingresando…' : 'Ingresar'}
          </Button>
        </form>
        <p className="mt-5 text-center text-xs text-gray-500">
          ¿Aún no tienes cuenta? Pídela en recepción: te llegará un enlace de activación al correo.
        </p>
        <p className="mt-2 text-center text-xs text-gray-400">
          <Link to="/" className="hover:underline">← Volver al sitio</Link>
        </p>
      </div>
    </div>
  )
}
